module.exports = __webpack_public_path__ + "static/media/0291a58c-55a2-40f0-a943-749fde53574f.16534ee1.jpg";